// extracted by mini-css-extract-plugin
export default {"container":"projects_container__0oGX7","popup":"projects_popup__j-42v"};